import {
	endpointsMap,
	IGetQuickSearchCategoriesOptions,
	IGetQuickSearchCategoriesResponse
} from './ICustomShopperQuickSearch';

import AbstractCustomShopperAPI from '../AbstractCustomShopperAPI';
import {ICustomApiConfig} from '../ICustomApiConfig';

/**
 * Represents CustomShopperQuickSearch
 */
class CustomShopperQuickSearch extends AbstractCustomShopperAPI {
	/**
	 * @constructor
	 * @param {ICustomApiConfig} config - API Config
	 */
	constructor(config: ICustomApiConfig) {
		super(config);
	}

	/**
	 * Gets the categories result for the given query
	 * @param {IGetQuickSearchCategoriesOptions} fetchOptions - options to pass to API Call
	 * @param {boolean} throwOnError - throw error if api returns error
	 *
	 * @returns {IGetQuickSearchCategoriesResponse} - Array of categories
	 */
	public async getQuickSearchCategories(
		fetchOptions: IGetQuickSearchCategoriesOptions,
		throwOnError?: boolean
	): Promise<IGetQuickSearchCategoriesResponse> {
		const response: IGetQuickSearchCategoriesResponse = await this.callCustomEndpoint<IGetQuickSearchCategoriesResponse>(
			fetchOptions,
			endpointsMap.GET_QUICKSEARCH_CATEGORIES
		);

		if (throwOnError && !response.data) {
			throw new Error('No categories retrieved.');
		}

		return response;
	}
}

export default CustomShopperQuickSearch;
